/**
 * Project-list filters. Kept dependency-free so they're testable without importing the
 * firebase-heavy useProjects hook.
 */

/** metadata.dealSource value stamped on dashboard CIM-teaser stub projects. */
export const DASHBOARD_CIM_TEASER_SOURCE = 'dashboard_cim_teaser';

/**
 * T3.3 — dashboard CIM-teaser "stub" projects are auto-created holders for a quick teaser, not
 * real deals. Exclude them from the main project list so they don't clutter it; the teaser
 * result stays reachable via its direct link and the teaser detail page (which loads by id).
 */
export const isDashboardTeaserStub = (project: {
  metadata?: { dealSource?: string };
}): boolean => project.metadata?.dealSource === DASHBOARD_CIM_TEASER_SOURCE;
